<template>
  <div class="layout-padding">
    <div class="btn-group-justify-end">
      <button @click="$router.push('board/create')" class="button is-primary">게시판 등록</button>
    </div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="게시판 조회"
      desc="등록한 게시판들의 현황을 조회할 수 있습니다."
    ></admin-filter>


    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1670"
                 nextPageName="post"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="title" slot-scope="props">
        <span style="border-bottom:1px solid;cursor:pointer"
              @click.stop.prevent="clickItem(props.item, 'move')">{{ props.item.title }}</span>
      </div>

      <div slot="permission_guest" slot-scope="props" style="white-space:pre-line">
        {{ props.item.permission_guest }}
      </div>

      <div slot="permission_partner" slot-scope="props" style="white-space:pre-line">
        {{ props.item.permission_partner }}
      </div>

      <div slot="permission_user" slot-scope="props" style="white-space:pre-line">
        {{ props.item.permission_user }}
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half" @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger" @click.stop.prevent="clickItem(props.item,'delete')">삭제</button>
      </div>
    </admin-table>

  </div>
</template>

<script>
  import moment from "moment";
  import LpSortDropDown from "../../module/common/LpSortDropDown";
  import LpInputText from "../../module/common/LpInputText";
  import LpRadio from "../../module/common/LpRadio";
  import LpModal from "../../module/common/LpModal.vue";
  import ListMixin from '@/mixins/ListMixin'
  import AdminFilter from "../../module/admin/AdminFilter";

  export default {
    name: 'BoardList',
    layout: "Main",
    mixins: [
      ListMixin
    ],
    components: {
      AdminFilter,
      LpSortDropDown,
      LpInputText,
      LpRadio,
      LpModal
    },
    created() {
      this.init();
    },
    data() {
      return {
        tableItems:undefined,
        modalEvent:0
      }
    },
    watch: {
      modalStatus(n) {
        if(n==='close'){
          location.reload();
        }
      }
    },
    methods: {
      init() {
        this.initializing('board', 'board');
        this.nowTime = moment().format("YY-MM-DD");
      },
      getDataFromServer() {
        this.getData();
      },
      clickItem(item, kind) {
        if (kind === "update") {
          this.$router.push("board/create?id=" + item.id);
        }
        else if (kind === "delete") {

          let value = {
            id: item.id,
            url: 'board/',
            title: item.title + ' 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
        else if (kind === 'move') {
          this.$router.push("board/" + item.id + "/post?title=" + item.title);
        }
      }
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  //@import '~assets/css/lp_main';

  .tr-whole-border th {
    padding: 12px 6px;
  }

  .many-field-tr td {
    padding: 6px;
  }

  .progress-btn {
    border-radius: 3px;
    display: inline-block;
    width: 84px;
    padding: 6px 0;
    margin: 2px;
    font-weight: bold;
    font-size: 0.8rem;
  }

  .bid-state {
    margin: 2px 0;
    color: #fff;
    border-radius: 3px;
    display: inline-block;
    width: 76px;
    padding: 4px;
  }

  .bid-state-ing {
    background-color: #1c7cd5;
  }

  .bid-state-ok {
    background-color: #5cb85c;
  }

  .bid-state-no {
    background-color: #f0ad4e;
  }
</style>
